import { useEffect, useState } from "react"
import URI from "../domain/URI.js"

/**
 * @description
 *	Gets the current location's URI of the active page or undefined if it's
 *	not available at the moment.
 */
export default function useLocation(): URI | undefined {
	const [href, setHref] = useState<string | undefined>(undefined)
	useEffect(() => setHref(window.location.href), [])
	return href ? URI.fromURL(new URL(href)) : undefined
}
